export const organizationSubscriptionEndpoints = {
  getEmbeddableMapsConfiguration:
    'vendor-dashboard/organization-subscriptions/v2/:organizationId/embeddable-maps',
  getHubSpotOrganizationSubscription:
    'vendor-dashboard/organization-subscriptions/v2/hubspot/:portalId',
};
